import {Component, Input, OnInit} from '@angular/core';
import {AbstractBffApi, HeaderstylesInterface} from '../../../models/sharedinterface';
import {AuthenticationService} from '../../../security/authentication.service';
import {ApiFactoryService} from '../../services/api-factory.service';
import {I18nService} from '../../services/i18n.service';

@Component({
  selector: 'app-dropdown-user',
  templateUrl: './dropdown-user.component.html',
  styleUrls: ['./dropdown-user.component.scss']
})
export class DropdownUserComponent implements OnInit {

  @Input() headerstyles: HeaderstylesInterface;
  @Input() userinfos: any;
  @Input() fullname: string;

  displayEdit = true;
  bffapi: AbstractBffApi;

  constructor(
    private authservice: AuthenticationService,
    private apifactory: ApiFactoryService,
    public i18n: I18nService,
  ) {
    this.bffapi = this.apifactory.createBffApi();
  }

  ngOnInit(): void {
    if (this.userinfos.hideprofile === '1') {
      this.displayEdit = false;
    }
  } // ngOnInit

  onLogout() {
    this.bffapi.logout().subscribe((data) => {
      this.authservice.logout();
    }, error => {
      this.authservice.logout();
    });
  }

  hideProfile() {
    this.bffapi.logout().subscribe((data) => {
      this.authservice.logout();
    }, error => {
      this.authservice.logout();
    });
  }

}
